module.exports = {
	"charset": "utf-8",
	"headers": {
		"last-translator": "Sebastian Felix Zappe <hypo@me.com>, 2017",
		"language-team": "English (United States) (https://www.transifex.com/sozialhelden/teams/67299/en_US/)",
		"content-type": "text/plain; charset=utf-8",
		"language": "en_US",
		"plural-forms": "nplurals=2; plural=(n != 1);"
	},
	"translations": {
		"": {
			"": {
				"msgid": "",
				"comments": {
					"translator": "Translators:\nSebastian Felix Zappe <hypo@me.com>, 2017"
				},
				"msgstr": [
					"Last-Translator: Sebastian Felix Zappe <hypo@me.com>, 2017\nLanguage-Team: English (United States) (https://www.transifex.com/sozialhelden/teams/67299/en_US/)\nContent-Type: text/plain; charset=utf-8\nLanguage: en_US\nPlural-Forms: nplurals=2; plural=(n != 1);\n"
				]
			},
			"No results.": {
				"msgid": "No results.",
				"comments": {
					"reference": "src/App.jsx:108 src/App.jsx:109 src/App.jsx:110 src/App.jsx:122\nsrc/App.jsx:126"
				},
				"msgstr": [
					""
				]
			},
			"Loading...": {
				"msgid": "Loading...",
				"comments": {
					"reference": "src/App.jsx:109 src/App.jsx:110 src/App.jsx:111 src/App.jsx:123\nsrc/App.jsx:127"
				},
				"msgstr": [
					""
				]
			},
			"Category": {
				"msgid": "Category",
				"comments": {
					"reference": "src/components/Result.jsx:102 src/components/Result.jsx:107\nsrc/components/Result.jsx:109"
				},
				"msgstr": [
					""
				]
			},
			"HTTP error from server.": {
				"msgid": "HTTP error from server.",
				"comments": {
					"reference": "src/components/XHRComponent.jsx:82"
				},
				"msgstr": [
					""
				]
			},
			"Accessible with wheelchair": {
				"msgid": "Accessible with wheelchair",
				"comments": {
					"reference": "src/model/PlaceInfo.js:66"
				},
				"msgstr": [
					"Accessible with wheelchair"
				]
			},
			"Partially accessible with wheelchair": {
				"msgid": "Partially accessible with wheelchair",
				"comments": {
					"reference": "src/model/PlaceInfo.js:67"
				},
				"msgstr": [
					"Partially accessible with wheelchair"
				]
			},
			"Not accessible with wheelchair": {
				"msgid": "Not accessible with wheelchair",
				"comments": {
					"reference": "src/model/PlaceInfo.js:68"
				},
				"msgstr": [
					"Not accessible with wheelchair"
				]
			},
			"meters": {
				"msgid": "meters",
				"comments": {
					"reference": "src/components/Distance.jsx:37"
				},
				"msgstr": [
					""
				]
			},
			"yards": {
				"msgid": "yards",
				"comments": {
					"reference": "src/components/Distance.jsx:44"
				},
				"msgstr": [
					""
				]
			},
			"miles": {
				"msgid": "miles",
				"comments": {
					"reference": "src/components/Distance.jsx:48"
				},
				"msgstr": [
					""
				]
			},
			"Show on OpenStreetMap": {
				"msgid": "Show on OpenStreetMap",
				"comments": {
					"reference": "src/components/Distance.jsx:54"
				},
				"msgstr": [
					""
				]
			},
			"${ value } ${ unit } from here.": {
				"msgid": "${ value } ${ unit } from here.",
				"comments": {
					"reference": "src/components/Distance.jsx:55"
				},
				"msgstr": [
					""
				]
			},
			"Yes": {
				"msgid": "Yes",
				"comments": {
					"reference": "src/components/AccessibilityDetails.jsx:16"
				},
				"msgstr": [
					"Yes"
				]
			},
			"No": {
				"msgid": "No",
				"comments": {
					"reference": "src/components/AccessibilityDetails.jsx:17"
				},
				"msgstr": [
					"No"
				]
			},
			"Show ‘${ props.properties.name }’ on ${ sourceName }": {
				"msgid": "Show ‘${ props.properties.name }’ on ${ sourceName }",
				"comments": {
					"reference": "src/components/InfoPageLink.jsx:18"
				},
				"msgstr": [
					""
				]
			},
			"Sources:": {
				"msgid": "Sources:",
				"comments": {
					"reference": "src/components/ResultsList.jsx:41"
				},
				"msgstr": [
					""
				]
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en_US.po
// module id = 159
// module chunks = 0